import { options_premiumSubOption_TransferDomain } from './premiumDashboardTransferDomainSubCategory.locstring.json';
import { OptionSubCategory } from 'owa-options-core';
import { DomainTransferOption } from 'owa-domain-option';
import { FAQSecOption } from 'owa-domain-option';

let premiumDashboardTransferDomainSubCategory: OptionSubCategory = {
    key: 'transferDomain',
    titleStringKey: options_premiumSubOption_TransferDomain,
    options: [DomainTransferOption, FAQSecOption],
};

export default premiumDashboardTransferDomainSubCategory;
